import { gsap } from 'gsap';

const scrollStop = callback => {
  // Make sure a valid callback was provided
  if (!callback || typeof callback !== 'function') return;

  // Setup scrolling variable
  let isScrolling = false;

  // Listen for scroll events
  window.addEventListener(
    'scroll',
    () => {
      if (window.innerWidth <= 767) {
        gsap.to('.floating-cta-wrapper .floating-cta', {
          ease: 'power2.out',
          duration: 0,
          y: 0,
        });

        return;
      }

      // Clear our timeout throughout the scroll
      window.clearTimeout(isScrolling);

      // Set a timeout to run after scrolling ends
      isScrolling = setTimeout(() => {
        // Run the callback
        callback();
      }, 66);
    },
    false,
  );
};

scrollStop(() => {
  const noScroll = document.querySelector('body').classList.contains('u--no-scroll');

  if (!noScroll) {
    gsap.to('.floating-cta-wrapper .floating-cta', {
      ease: 'power2.out',
      duration: 0.6,
      y: window.pageYOffset,
    });
  }
});
